<template lang="pug" src="./penalty-editor.pug"></template>

<script>
import { mapState, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { demical } from '@/utils/helpers';
import validate from '@/mixins/validate';

import request from '@/utils/request';

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        penalty: {
            title: null,
            fixedPenalty: null,
            brandId: null
        },
        loaded: false,
        canSavePenalty: false,
        removeModal: false,
        requestProcessing: false
    }),
    validations: {
        penalty: {
            title: {
                required
            },
            fixedPenalty: {
                required,
                demical
            },
            brandId: {
                required
            }
        }
    },
    computed: {
        ...mapGetters(['userBrandId']),
        ...mapState({
            brands: state => state.data.brands
        }),
        saveMethod() {
            return this.penalty.id ? 'put' : 'post';
        },
        saveUrl() {
            return this.penalty.id ? `/admin/driver/penalties/${this.penalty.id}` : '/admin/driver/penalties';
        },
    },
    watch: {
        penalty: {
            handler: function() {
                this.canSavePenalty = true;
            },
            deep: true
        }
    },
    created() {
        if (this.userBrandId) {
            this.penalty.brandId = this.userBrandId;
        }

        if (this.$route.params.id) {
            this.loaded = true;
            this.loadData();
        }

        this.$store.dispatch('data/getBrands');
    },
    methods: {
        async loadData() {
            await request({ method: 'get', url: `/admin/driver/penalties/${this.$route.params.id}` })
                .then(res => this.successLoad(res)).catch(error => {
                    if(error.response && error.response.data && error.response.data.error) {
                        this.$store.dispatch('alert/addMessage', {
                            message: error.response.data.error
                        });
                    }
                });
        },

        async savePenalty() {
            if (this.$v.penalty.$invalid) {
                this.$v.penalty.$touch();

                this.$nextTick(() => this.focusFirstErrorInput());
                return;
            }

            if (this.requestProcessing) return;

            this.requestProcessing = true;

            const data = Object.assign({}, this.penalty);

            await request({ method: this.saveMethod, url: this.saveUrl, data })
                .then(res => {
                    this.successLoad(res);

                    if (!this.$route.params.id) {
                        this.$router.push(`/finances/penalties/editor/${this.penalty.id}`);
                    }

                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    });
                }).catch(error => {
                    const message = error.response && error.response.data && error.response.data.error;

                    if(message) {
                        this.$store.dispatch('alert/addMessage', {
                            message: this.$vuetify.lang.t(`$vuetify.messages.error.payments.${message}`),
                            locale: false
                        });
                    }
                }).finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        },

        successLoad(res) {
            this.penalty = Object.assign({}, this.penalty, res.data);

            this.$nextTick(() => {
                this.canSavePenalty = false;
                this.loaded = false;
            });
        },

        async remove() {
            if (this.loaded) return;

            this.loaded = true;

            await request({ method: 'delete', url: `/admin/driver/penalties/${this.penalty.id}` })
                .then(() => {
                    this.$router.push(`/finances/penalties`);
                }).catch(error => {
                    if(error.response && error.response.data && error.response.data.error) {
                        this.$store.dispatch('alert/addMessage', {
                            message: error.response.data.error
                        });
                    }
                }).finally(() => {
                    this.$nextTick(() => {
                        this.removeModal = false;
                        this.loaded = false;
                    });
                });
        }
    }
};
</script>
